import { Header } from '@asgard/ui-library';
import { StyledHeader } from './PortalHeader.styled';
import { PortalHeaderProps } from './PortalHeader.types';

export const PortalHeader: React.FC<PortalHeaderProps> = ({
  title,
  children
}) => {
  return (
    <StyledHeader>
      <Header as="h3">{title}</Header>

      {children}
    </StyledHeader>
  );
};
